import React from 'react'
import { makeClickableContent } from './styled'

export const RawClickableContent = makeClickableContent('a')

function ClickableContent(props) {
  return <RawClickableContent {...props} />
}

export default ClickableContent
